import { useState } from "react";
import { IS_FAVORITE_DEBUG } from "@/constants";
import { ListItemTitle } from "../ListItemTitle";
import { BareButton } from "@/components";
import { IPanelScope, ITreeItem } from "@/interfaces";
import { ListTypes } from "@/enums";
import { MuxFavorite, MuxToggle } from "@/Icons";
import { FavoriteItem } from "@/types";
import styles from "./ListItemRow.module.scss";
import {
  PT_TREE_ITEM_TESTID,
  PT_TREE_TOGGLE_BUTTON_TESTID,
} from "@/constants/test-ids";

interface ListItemRowProps {
  data: ITreeItem | FavoriteItem; //  Refactor this to use ITreeItem, or create generic type
  paddingLeft: number;
  isSelected: boolean;
  hasChildren: boolean;
  isEditable: boolean;
  getContextMenu?: (show: boolean) => void;
  scope: IPanelScope;
  criteria: string;
  isFavorite: boolean;
  isTreeNodeExpand: boolean;
  isDataReady?: boolean;
  onExpandStateChanged?: () => void;
  handleRename?: (value: string) => Promise<void>;
  handleNodeClicked: (
    e: React.MouseEvent,
    node: ITreeItem | FavoriteItem,
  ) => void;
  handleFavoriteClick: (f: FavoriteItem) => void;
  ContextMenu?: React.ReactElement | null;
  type?: ListTypes;
}

export const ListItemRow = ({
  data,
  paddingLeft,
  isSelected,
  hasChildren,
  scope,
  criteria,
  isEditable,
  isDataReady = false,
  type = ListTypes.FILTERS,
  isTreeNodeExpand,
  getContextMenu,
  ContextMenu,
  handleFavoriteClick,
  handleRename,
  onExpandStateChanged,
  handleNodeClicked,
}: ListItemRowProps) => {
  const [isHover, setIsHover] = useState<boolean>(false);

  const onFavoriteClick = () => {
    handleFavoriteClick && handleFavoriteClick(data as FavoriteItem);
  };

  const handleExpandIconClicked = () => {
    onExpandStateChanged && onExpandStateChanged();
  };

  const handleNodeChange = (
    e: React.MouseEvent,
    node: ITreeItem | FavoriteItem,
  ) => {
    handleNodeClicked(e, node);
  };

  return (
    <li
      className={`${styles.node} ${isSelected && styles.activeFilter} ${type == ListTypes.FAVORITES && styles.favorite}`}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div
        className={`${styles.itemRow}`}
        style={{ paddingLeft }}
        data-testid={PT_TREE_ITEM_TESTID}
      >
        {hasChildren && onExpandStateChanged && (
          <BareButton
            dataTestId={PT_TREE_TOGGLE_BUTTON_TESTID}
            handleClick={handleExpandIconClicked}
            className={`${styles.barebtn} ${isTreeNodeExpand ? styles["collapse-node"] : styles["expand-node"]}`}
          >
            <MuxToggle />
          </BareButton>
        )}
        <ListItemTitle
          type={type}
          name={data.name}
          handleRename={handleRename}
          isEditable={isEditable}
          criteria={criteria}
          scope={scope}
          data={data}
          isSelected={isSelected}
          handleClickFilter={handleNodeChange}
          isOpen={isTreeNodeExpand}
          isDataReady={isDataReady}
          isHover={isHover}
        />
        {IS_FAVORITE_DEBUG && (
          <BareButton handleClick={onFavoriteClick}>
            <MuxFavorite />
          </BareButton>
        )}
        {getContextMenu && getContextMenu(isHover)}
        {ContextMenu && isHover && ContextMenu}
      </div>
    </li>
  );
};
